import React, { FC, ReactNode } from 'react';

import getClassName from 'src/common/utils/getClassName';
import s from './Header.module.scss';

type BareHeaderProps = {
  children?: ReactNode;
  extraChildren?: ReactNode;
  classNameModifier?: string;
};

const BareHeader: FC<BareHeaderProps> = ({
  children,
  extraChildren,
  classNameModifier,
}) => (
  <div className={getClassName(s, 'root', classNameModifier)}>
    {extraChildren}
    <div className={getClassName(s, 'innerWrapper', `${classNameModifier}`)}>
      {children}
    </div>
  </div>
);

export default BareHeader;
